<template>
  <v-container>
    <v-row>
      <v-col cols="12 py-0">
        <v-toolbar
          flat
          height="88px"
        >
          <v-icon class="mr-2">
            {{ $appConfig.trigger.icon }}
          </v-icon>
          <v-toolbar-title>Create Task</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <!-- Wizard START -->
      <v-col cols="12">
        <v-stepper
          v-model="currStep"
          value
          transition="fade-transition"
          class="hide-border"
        >
          <!-- Wizard top steps names START -->
          <v-stepper-header class="grey lighten-4">
            <v-stepper-step
              step="1"
              :complete="step > 1"
            >
              Choose a service
            </v-stepper-step>
            <v-divider />
            <v-stepper-step
              step="2"
              :complete="step > 2"
            >
              Define a trigger
            </v-stepper-step>
            <v-divider />
            <v-stepper-step step="3">
              Choose a function
            </v-stepper-step>
          </v-stepper-header>
          <!-- Wizard top steps names END -->
          <v-row>
            <v-col>
              <!-- Wizard step 1 START -->
              <v-stepper-content
                step="1"
                class="pa-0"
              >
                <v-container class="text-center">
                  <v-row>
                    <v-col>
                      <h2>
                        Step {{ currStep }} : choose a
                        service
                      </h2>
                    </v-col>
                  </v-row>
                  <v-row
                    justify="center"
                    class="pa-5"
                  >
                    <v-col
                      v-for="element in stepOneItems"
                      :key="element.id"
                      cols="12"
                      sm="8"
                      md="6"
                      lg="4"
                    >
                      <v-card
                        height="100%"
                        hover
                        color="grey lighten-5"
                        @click="
                          switchItem(element.type)
                        "
                      >
                        <v-card-text>
                          <v-icon
                            x-large
                            color="primary"
                          >
                            {{ element.icon }}
                          </v-icon>
                          <v-col
                            cols="12"
                            class="headline primary--text"
                          >
                            {{ element.text }}
                          </v-col>
                          <v-col
                            cols="12"
                            class="body-1 grey--text font-weight-light"
                          >
                            {{
                              element.description
                            }}
                          </v-col>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-stepper-content>
              <!-- Wizard step 1 END -->

              <!-- Wizard step 2 START -->
              <v-stepper-content step="2">
                <v-container>
                  <v-row
                    class="text-center"
                    justify="center"
                  >
                    <v-col>
                      <h2>
                        Step {{ currStep }} : define a
                        trigger
                      </h2>
                    </v-col>
                  </v-row>
                  <v-row
                    class="gutter"
                    justify="center"
                  >
                    <v-col>
                      <trigger-step-calendar
                        v-if="item === 'date_time'"
                        :curr-step="currStep"
                        :curr-sub-step="currSubStep"
                        :trigger="trigger"
                        @nextStep="nextStep()"
                        @sendTriggerState="
                          updateTrigger
                        "
                      />
                      <trigger-step-dataset
                        v-if="item === 'dataset'"
                        :curr-step="currStep"
                        :curr-sub-step="currSubStep"
                        :trigger="trigger"
                        @nextStep="nextStep()"
                        @sendTriggerState="
                          updateTrigger
                        "
                      />
                      <trigger-step-api
                        v-if="item === 'api'"
                        :curr-step="currStep"
                        :curr-sub-step="currSubStep"
                        :trigger="trigger"
                        @nextStep="nextStep()"
                        @sendTriggerState="
                          updateTrigger
                        "
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-stepper-content>
              <!-- Wizard step 2 END -->

              <!-- Wizard step 3 START -->
              <v-stepper-content step="3">
                <v-container>
                  <v-row
                    class="text-center"
                    justify="center"
                  >
                    <v-col>
                      <h2>
                        Step {{ currStep }} : choose a
                        function
                      </h2>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col>
                      <trigger-step-function
                        :trigger="trigger"
                        :selected="selected"
                        @selected="
                          handleFunctionSelection
                        "
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-stepper-content>
              <!-- Wizard step 3 END -->

              <!-- Wizard step 4 START -->
              <v-stepper-content step="4">
                <v-container>
                  <v-row
                    class="text-center"
                    justify="center"
                  >
                    <v-col><h2>Summary</h2></v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                      cols="12"
                      sm="8"
                      md="4"
                      lg="4"
                    >
                      <trigger-step-create
                        v-if="currStep === 4"
                        :trigger="trigger"
                        @createTrigger="createTrigger"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-stepper-content>
              <!-- Wizard step 4 END -->
            </v-col>
          </v-row>
          <v-row
            justify="center"
            class="pa-3"
          >
            <v-btn
              v-if="currStep != 1"
              x-large
              text
              @click.native="previousStep"
            >
              <v-icon left>
                mdi-arrow-left
              </v-icon>
              Previous
            </v-btn>
            <v-btn
              v-if="currStep === 2 || currStep === 3"
              x-large
              text
              :disabled="isNextStepUnlocked === false"
              @click.native="nextStep"
            >
              Next
              <v-icon right>
                mdi-arrow-right
              </v-icon>
            </v-btn>
            <v-btn
              v-if="currStep === 4"
              color="primary"
              :disabled="isCreateUnlocked === false"
              @click.native="createTrigger"
            >
              <v-icon>mdi-shape-circle-plus</v-icon>
              Create
            </v-btn>
            <v-btn
              v-if="trigger.type === 'dataset' && currStep === 4"
              :disabled="isCreateUnlocked === true"
              :to="{
                name: 'view-object',
                params: {
                  object: 'dataset',
                  identifier: trigger.source
                }
              }"
            >
              go to dataset page
              <v-icon>mdi-arrow_right</v-icon>
            </v-btn>
            <v-btn
              v-if="trigger.type === 'api' && currStep === 4"
              text
              :disabled="isCreateUnlocked === true"
              :to="{
                name: 'view-object',
                params: {
                  object: 'api',
                  identifier: trigger.source
                }
              }"
            >
              go to API page
              <v-icon>mdi-arrow_right</v-icon>
            </v-btn>
            <v-btn
              v-if="
                trigger.type === 'date_time' && currStep === 4
              "
              text
              :disabled="isCreateUnlocked === true"
              :to="{
                name: 'view-object',
                params: {
                  object: 'function',
                  identifier: fn.id
                }
              }"
            >
              go to function page
              <v-icon>mdi-arrow_right</v-icon>
            </v-btn>
          </v-row>
        </v-stepper>
      </v-col>
      <!-- Wizard END -->
    </v-row>
  </v-container>
</template>

<script>
  import FunctionService from './../Functions/services/FunctionService'
  import TriggerService from './services/TriggerService'
  import TriggerStepCalendar from './TriggerStepChooseType_DateTime.vue'
  import TriggerStepDataset from './TriggerStepChooseType_Dataset.vue'
  import TriggerStepApi from './TriggerStepChooseType_Api.vue'
  import TriggerStepFunction from './TriggerStepChooseFunction.vue'
  import TriggerStepCreate from '../../../UIComponents/Cards/TriggerCard.vue'

  export default {
    components: {
      TriggerStepCalendar,
      TriggerStepDataset,
      TriggerStepApi,
      TriggerStepFunction,
      TriggerStepCreate,
    },
    props: {
      type: {},
      source: {},
    },
    data () {
      return {
        fn: {},
        trigger: {},
        step: '',
        currStep: 1,
        currSubStep: 1,
        selected: '',
        isNextStepUnlocked: false,
        isCreateUnlocked: true,
        isTriggerCreated: Boolean,
        chosenSource: '',
        stepOneItems: [
          {
            id: 1,
            type: 'date_time',
            text: 'Date & Time',
            description:
              'Define a trigger based on time elements. Example: apply a specific function every hour, day, month and/or year',
            icon: this.$appConfig.date_time.icon,
            color: 'secondary',
          },
          {
            id: 2,
            type: 'dataset',
            text: 'Dataset',
            description:
              'Define a trigger based on an interaction with a dataset. Example: apply a specific function before or after an update, an insert or a read',
            icon: this.$appConfig.dataset.icon,
            color: 'secondary',
          },
          {
            id: 3,
            type: 'api',
            text: 'Api',
            description:
              'Define a trigger based on an interaction with an API. Example: apply a specific function before or after a call to the API',
            icon: this.$appConfig.api.icon,
            color: 'secondary',
          },
        ],
        item: '',
      }
    },
    mounted () {
      const params = this.$route.query
      const dataset = { hmd_id: params.service }
      if (['dataset', 'api'].includes(params.service_type)) {
        TriggerService.getSource(params.service_type, dataset).then(
          result => {
            this.trigger.source = result.data
            this.chosenSource = result.data
            this.switchItem(params.service_type)
          }
        )
      }
      if (params.function) {
        FunctionService.get(params.function, this).then(r => {
          this.selected = r.data
          this.fn = r.data
        })
      }

      if (
        this.type === 'date_time' ||
        this.type === 'dataset' ||
        this.type === 'api'
      ) {
        this.switchItem(this.type)

        if (this.type !== 'date_time') {
          if (typeof this.source !== 'undefined') {
            TriggerService.getSource(this.type, this.source).then(
              result => {
                this.trigger.source = result.data
                this.currSubStep = 2
              }
            )
          } else {
            this.currSubStep = 1
          }
        }
        this.currStep = 2
      } else {
        this.currStep = 1
        this.currSubStep = 1
      }
    },
    methods: {
      handleFunctionSelection (func) {
        this.fn = func
        this.updateTrigger(this.trigger)
      },
      previousStep () {
        if (this.currStep === 2) {
          if (this.currSubStep === 1) {
            this.currStep = 1
          } else {
            this.currSubStep = 1
          }
        } else if (this.currStep === 3) {
          this.currSubStep = 2
          this.currStep = 2
        } else {
          this.currStep--
        }
        if (this.currStep === 3) {
          this.fn = null
        }
        if (this.trigger.type !== 'date_time') {
          this.trigger.source = this.chosenSource
        }
        this.updateTrigger(this.trigger)
        this.isCreateUnlocked = true
      },
      nextStep () {
        if (this.currStep === 2) {
          if (this.currSubStep === 1) {
            this.currSubStep = 2
          } else this.currStep = 3
        } else this.currStep++
        if (this.trigger.type !== 'date_time') {
          this.chosenSource = this.trigger.source
        }
        this.updateTrigger(this.trigger)
      },
      switchItem (item) {
        this.item = item
        if (this.trigger.type != this.item) {
          this.trigger = {}
        }
        if (this.trigger.type === undefined) {
          this.trigger.type = item
        }
        this.currStep = 2
        this.updateTrigger(this.trigger)
      },
      updateTrigger (newTriggerState) {
        this.trigger = newTriggerState
        if (this.fn) {
          this.selected = this.fn
          this.trigger.function = this.fn
        }

        if (this.currStep === 2) {
          if (this.trigger.type === 'date_time') {
            if (
              this.currSubStep === 2 &&
              this.trigger.minute_choice != null
            ) {
              if (
                this.trigger.freq_choice === 'HOUR' ||
                (this.trigger.freq_choice === 'DAY' &&
                this.trigger.hour_choice != null) ||
                (this.trigger.freq_choice === 'WEEK' &&
                this.trigger.hour_choice != null &&
                typeof this.trigger.day_choice !==
                'undefined' &&
                this.trigger.day_choice.length > 0) ||
                (this.trigger.freq_choice === 'MONTH' &&
                this.trigger.hour_choice != null &&
                this.trigger.date_choice != null) ||
                (this.trigger.freq_choice === 'YEAR' &&
                this.trigger.hour_choice != null &&
                this.trigger.date_choice != null &&
                this.trigger.month_choice != null)
              ) {
                this.isNextStepUnlocked = true
              } else {
                this.isNextStepUnlocked = false
              }
            } else {
              this.isNextStepUnlocked = false
            }
          }
          if (this.trigger.type === 'dataset') {
            if (this.currSubStep === 2) {
              if (
                this.trigger.fetch_choice != null &&
                this.trigger.request_choice != null
              ) {
                this.isNextStepUnlocked = true
              }
            } else {
              this.isNextStepUnlocked = false
            }
          }
          if (this.trigger.type === 'api') {
            if (this.currSubStep === 2) {
              if (this.trigger.fetch_choice != null) {
                this.isNextStepUnlocked = true
              }
            } else {
              this.isNextStepUnlocked = false
            }
          }
        }

        if (this.currStep === 3) {
          if (this.fn != null) {
            this.isNextStepUnlocked = true
          } else {
            this.isNextStepUnlocked = false
          }
        }
      },
      createTrigger () {
        this.isCreateUnlocked = false
        if (this.trigger.type === 'date_time') {
          if (this.trigger.freq_choice != 'YEAR') {
            this.trigger.month_choice = null
          }
          if (
            this.trigger.freq_choice != 'YEAR' &&
            this.trigger.freq_choice != 'MONTH'
          ) {
            this.trigger.date_choice = null
          }
          if (this.trigger.freq_choice != 'WEEK') {
            this.trigger.day_choice = {}
          }
          if (this.trigger.freq_choice === 'HOUR') {
            this.trigger.hour_choice = null
          }
        }
        const triggerSent = this.trigger
        triggerSent.function = triggerSent.function.name
        if (triggerSent.type !== 'date_time') {
          triggerSent.source = this.chosenSource.name
        }
        TriggerService.createTrigger(triggerSent, this)
        this.isCreateUnlocked = false
      },
    },
  }
</script>
